import React, { PropsWithChildren } from 'react';

import { Box, Divider } from '@vp/swan';

interface FlyoutElementProps {
  isLast?: boolean;
}
export const FlyoutElement: React.FC<PropsWithChildren<FlyoutElementProps>> = (props) => (
  <Box>
    {props.children}
    <Divider mt="between-actions" mb={props.isLast ? 0 : 'between-actions'} />
  </Box>
);
